module.exports = __webpack_public_path__ + "img/logo.952d4a65.png";